import { render, staticRenderFns } from "./info-circle.vue?vue&type=template&id=6079cf4f&"
import script from "./info-circle.vue?vue&type=script&lang=js&"
export * from "./info-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6079cf4f')) {
      api.createRecord('6079cf4f', component.options)
    } else {
      api.reload('6079cf4f', component.options)
    }
    module.hot.accept("./info-circle.vue?vue&type=template&id=6079cf4f&", function () {
      api.rerender('6079cf4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/info-circle.vue"
export default component.exports